import React from "react";
import { useTranslation } from "react-i18next";
import { LinkButton } from "./LinkButton";

export const DifferentEmailLink: React.FC<{
  online: boolean;
  onClick(): void;
}> = ({ online, onClick }) => {
  const { t } = useTranslation();
  return (
    <LinkButton onClick={onClick} disabled={!online}>
      {t("Log in with a different email")}
    </LinkButton>
  );
};

export const ForgetEmailLink: React.FC<{
  email: string;
  online: boolean;
  onForget(): void;
}> = ({ email, online, onForget }) => {
  const { t } = useTranslation();
  return (
    <LinkButton
      onClick={onForget}
      disabled={!online}
      ariaLabel={`${t("Forget this email")} ${email}`}
      title={
        online
          ? undefined
          : t("Forgetting an email needs an internet connection.")
      }
      testId="forget-email-button"
    >
      {t("Forget this email")}
    </LinkButton>
  );
};
